<div v-if="loading" class="loader">
    <!-- Add your loader HTML/CSS here -->
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>